import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubAboutHeSourcesHeaderCls: string;
			heHubAboutHeSourcesItemCls: string;
		}
	},

	slug: string
}

class Sources extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub About He Sources Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeSourcesHeaderCls || '', 'he_hub_about_he_sources', { animCls: 'animate__flipInX', once: true});
		if(this.publicVars.cssId.anim?.heHubAboutHeSourcesItemCls) {
			const sourcesItemsCount = document.querySelectorAll(this.publicVars.cssId.anim?.heHubAboutHeSourcesItemCls).length;

			for(let i = 1; i <= sourcesItemsCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeSourcesItemCls + i, 'he_hub_about_he_sources', { animCls: 'animate__fadeIn', once: true});
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default Sources;